import Sticky from 'react-stickynode'
import styled from 'styled-components'

export const StickyNode = styled(Sticky)`
  > div {
    left: 0;
  }
`
